import { render } from "./PdfAcceptModal.vue?vue&type=template&id=5cc3c0ac&ts=true"
import script from "./PdfAcceptModal.vue?vue&type=script&lang=ts"
export * from "./PdfAcceptModal.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__